interface StepHintProps {
  hint: string
}

const StepHint: React.FC<StepHintProps> = ({ hint }) => {
  return <div dangerouslySetInnerHTML={{ __html: hint }} className="step-hint" />
}

export default StepHint;
